const AVATAR_SHAPE_COLORS = {
  user: 'e11d48',
  business: '358e8d',
  client: 'ab2374',
};

const getDicebearThumbsUrl = (seed, shapeColor, size = 40) => {
  if (!seed) return null;

  const normalizedSeed = String(seed).trim();
  return `https://api.dicebear.com/9.x/thumbs/svg?backgroundColor=9e1432&shapeColor=${shapeColor}&seed=${encodeURIComponent(
    normalizedSeed,
  )}&size=${size}`;
};

export const getStandardAvatarUrl = ({ type = 'user', entityId, url, size = 40 }) => {
  if (url) return url;
  if (!entityId) return null;

  const shapeColor = AVATAR_SHAPE_COLORS[String(type).toLowerCase()] || AVATAR_SHAPE_COLORS.user;
  return getDicebearThumbsUrl(entityId, shapeColor, size);
};

const getProfilePictureUrl = (profilePicture) => {
  if (!profilePicture) return null;
  if (typeof profilePicture === 'string') return profilePicture;
  return profilePicture.url;
};

export const getUserAvatarUrl = (user, size = 40) => {
  if (!user) return null;

  const profilePictureUrl = getProfilePictureUrl(user.profilePicture);
  if (profilePictureUrl) return profilePictureUrl;

  return getStandardAvatarUrl({ type: 'user', entityId: user.id, size });
};

export const getClientAvatarUrl = (client, size = 40) => {
  if (!client) return null;

  const profilePictureUrl = getProfilePictureUrl(client.profilePicture);
  if (profilePictureUrl) return profilePictureUrl;

  return getStandardAvatarUrl({ type: 'client', entityId: client.id, size });
};

export const getBusinessAvatarUrl = (business, size = 40) => {
  if (!business) return null;

  if (business.iconUrl) return business.iconUrl;
  return getStandardAvatarUrl({ type: 'business', entityId: business.businessId, size });
};
